( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {

        function init() {

            if ( Barba.HistoryManager.prevStatus() && typeof( wpcf7.initForm ) === 'function' ) {
                $( 'div.wpcf7 > form' ).each( function() {
                    var sjm_form = $( this );
                    wpcf7.initForm( sjm_form );
                } );
            }

            // Show confirmation message on successful form submit
            $( '.wpcf7' ).on( 'wpcf7:mailsent', function( event ) {
                $( '.js--contact-form-success-message' ).fadeIn( 500 );
            } );

            // Show error message if form does not submit
            $( '.wpcf7' ).on( 'wpcf7:mailfailed', function() {
                alert( 'Form error! Your message could not be sent. Please email us directly using the link below. Sorry for the inconvenience.' );
            } );
        }

        init();

        // Run again when PJAX navigates to a new page
        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {
                init();
            } );
        }

    } );
} )( window, document, jQuery );
